import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const productStatusSchema = z.enum([
  "complete",
  "partial-completion",
  "reopened",
  "not-started",
]);

export const getMerchantProductStatuses = unaryRpc({
  name: "getMerchantProductStatuses",
  input: z.object({ merchantId: z.string() }),
  output: z.object({
    returns: productStatusSchema,
    orderEditing: productStatusSchema,
  }),
});

export type ProductStatus = z.infer<typeof productStatusSchema>;
